export const messages = {
  en: {
    parkingAreaManage: {
      queryTitle: 'Query Conditions',
      parkingInfo: 'Parking Area Information',
      parkingId: 'Parking ID',
      parkingNum: 'Parking Number',
      parkingType: 'Parking Type',
      inputParkingNum: 'Please enter parking number',
      selectParkingType: 'Please select parking type',
      aboveGround: 'Above Ground Parking',
      underground: 'Underground Parking',
      remark: 'Remark',
      createTime: 'Create Time',
      tempCarQty: 'Temp Car Capacity',
      tempCarQtyTip: '0 = unlimited',
      operation: 'Operation',
      controlPanel: 'Control Panel',
      addTitle: 'Add Parking Area',
      editTitle: 'Edit Parking Area',
      deleteTitle: 'Confirm Operation',
      deleteConfirm: 'Are you sure to delete this parking area?',
      numRequired: 'Parking number is required',
      typeRequired: 'Parking type is required',
      remarkPlaceholder: 'Optional, please enter remark',
      attr1: 'Area Size',
      attr1Placeholder: 'Please enter area size',
      attr2: 'Parking Type',
      selectAttr2: 'Please select parking type',
      option1: 'Standard',
      option2: 'VIP',
      column1: 'Capacity',
      column2: 'Available',
      addSuccess: 'Parking area added successfully',
      addFailed: 'Failed to add parking area',
      editSuccess: 'Parking area updated successfully',
      editFailed: 'Failed to update parking area',
      deleteSuccess: 'Parking area deleted successfully',
      deleteFailed: 'Failed to delete parking area',
      fetchError: 'Failed to fetch parking area data'
    }
  },
  zh: {
    parkingAreaManage: {
      queryTitle: '查询条件',
      parkingInfo: '停车场信息',
      parkingId: '停车场ID',
      parkingNum: '停车场编号',
      parkingType: '停车场类型',
      inputParkingNum: '请输入停车场编号',
      selectParkingType: '请选择停车场类型',
      aboveGround: '地上停车场',
      underground: '地下停车场',
      remark: '备注',
      createTime: '创建时间',
      tempCarQty: '临时车位数',
      tempCarQtyTip: '0表示不限制临时车入场数量',
      operation: '操作',
      controlPanel: '控制台',
      addTitle: '添加停车场',
      editTitle: '修改停车场',
      deleteTitle: '确认操作',
      deleteConfirm: '是否确定删除该停车场？',
      numRequired: '停车场编号不能为空',
      typeRequired: '停车场类型不能为空',
      remarkPlaceholder: '可选，请填写备注',
      attr1: '区域大小',
      attr1Placeholder: '请输入区域大小',
      attr2: '停车类型',
      selectAttr2: '请选择停车类型',
      option1: '标准',
      option2: 'VIP',
      column1: '容量',
      column2: '可用',
      addSuccess: '停车场添加成功',
      addFailed: '停车场添加失败',
      editSuccess: '停车场修改成功',
      editFailed: '停车场修改失败',
      deleteSuccess: '停车场删除成功',
      deleteFailed: '停车场删除失败',
      fetchError: '获取停车场数据失败'
    }
  }
}